import './Card.css';
export default {
    "card--contained": "Card_card--contained__vj7ua",
    "card--stretched": "Card_card--stretched__vj7ua",
    "contentWrapper": "Card_contentWrapper__vj7ua",
    "body": "Card_body__vj7ua",
    "title": "Card_title__vj7ua",
    "readMore": "Card_readMore__vj7ua"
};
